import { render, staticRenderFns } from "./myMessage.vue?vue&type=template&id=1893570f&scoped=true&"
import script from "./myMessage.vue?vue&type=script&lang=js&"
export * from "./myMessage.vue?vue&type=script&lang=js&"
import style0 from "./myMessage.vue?vue&type=style&index=0&id=1893570f&lang=scss&scoped=true&"
import style1 from "./myMessage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!///node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1893570f",
  null
  
)

export default component.exports